module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/widget-reportes-ok.225340a6.svg";